/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Request body of login with magic link endpoint
 */
export interface Tokens { 
    /**
     * Access token (JWT)
     */
    accessToken: string;
    /**
     * Refresh token (JWT)
     */
    refreshToken: string;
    /**
     * Type of the access token.  - Bearer: the token is a Bearer token 
     */
    type: Tokens.TypeEnum;
    /**
     * Expiration of the access token
     */
    expiresAt: Date;
}
export namespace Tokens {
    export type TypeEnum = 'Bearer';
    export const TypeEnum = {
        Bearer: 'Bearer' as TypeEnum
    };
}